import script from "./header-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./header-menu.vue?vue&type=script&setup=true&lang=ts"

import "./header-menu.vue?vue&type=style&index=0&id=6458679a&lang=css"

const __exports__ = script;

export default __exports__